import React from 'react';
import { connect } from 'react-redux';


class Home extends React.Component {

  render() {
    return (
      <main>
        <h1>Bienvenido Propietario</h1>
      </main>
    );
  }
}

export default connect(state => ({
  user: state.user,
}))(Home);
